import { Link } from 'react-router-dom';
import { DIRECTIONS_URL, hours, visitImage } from '@/mocks/home';

export default function Visit() {
  return (
    <section id="visit" className="bg-background-100 py-16 md:py-28">
      <div className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-10">
        <div className="lg:col-span-6 relative w-full aspect-[4/3] lg:aspect-auto lg:h-full lg:min-h-[420px] overflow-hidden">
          <img src={visitImage} width={1400} height={1050} loading="lazy" decoding="async" alt="NOVA Hair Studio reception and styling floor" title="Visit NOVA Hair Studio" className="absolute inset-0 w-full h-full object-cover object-top" />
        </div>
        <div className="lg:col-span-5 lg:col-start-8 flex flex-col justify-center">
          <h2 className="font-heading font-semibold tracking-[-0.02em] text-[36px] md:text-[52px] leading-[1.05] text-foreground-950">Find Us</h2>
          <p className="mt-6 text-[16px] font-medium text-foreground-950">NOVA Hair Studio</p>
          <address className="not-italic mt-2 text-[15px] text-foreground-700 leading-relaxed">
            [Street address]<br />[City, Postcode]<br />[Phone number] · [Email]
          </address>
          <ul className="mt-8 border-t border-foreground-950">
            {hours.map((h) => (
              <li key={h.day} className="flex justify-between py-3 border-b border-background-300 text-[14px]">
                <span className="text-foreground-950">{h.day}</span>
                <span className="text-foreground-600">{h.time}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-3">
            {DIRECTIONS_URL ? (
              <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-sm border border-foreground-950 px-6 py-4 text-sm text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                Get Directions <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line"></i></span>
              </a>
            ) : (
              <Link to="/visit" className="inline-flex items-center gap-2 rounded-sm border border-foreground-950 px-6 py-4 text-sm text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                Plan your visit <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line"></i></span>
              </Link>
            )}
          </div>
          <p className="mt-3 text-[12px] text-foreground-500">Directions link connects once the address is confirmed.</p>
        </div>
      </div>
    </section>
  );
}